
import {PropType} from 'vue';
import {AuthAppService} from '../../src/AuthAppService';

export default {
    props: {
        service: {
            type: Object as PropType<AuthAppService>,
        },
    },
    emits: ['back'],
    methods: {
        onBack() {
            this.$emit('back');
        }
    },
};
